import {
    LabelBody,
    LabelHeader4,
    SecondaryButton,
    Spacer,
} from '../../components';
import { IllustrationOverwhelmingThoughts } from '../../icons';

type Page1Props = {
    onContinue: () => void;
};
export function Page1({ onContinue }: Page1Props) {
    return (
        <>
            <LabelHeader4 className="mb-10">
                Klar til at finde din vej?
            </LabelHeader4>
            <LabelBody>
                Mærk efter: Hvad fylder i din hverdag? Og hvad er egentlig
                vigtigt for dig? Der er nemlig forskel, og der er ikke altid
                balance mellem dét der fylder og den tid vi bruger.
            </LabelBody>
            <LabelBody className="my-10">
                Denne øvelse hjælper dig med at se, om du bruger din tid på det,
                der giver dig energi og føles rigtigt for dig.
            </LabelBody>
            <IllustrationOverwhelmingThoughts className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Videre til øvelsen
            </SecondaryButton>
        </>
    );
}
